import { Link, Outlet } from 'react-router'
import { AuthBadge } from './ui/components/AuthBadge'
import { ConsentPrompt } from './ui/components/ConsentPrompt'
import { HealthPill } from './ui/components/HealthPill'
import { LocaleSwitcher } from './ui/components/LocaleSwitcher'
import { ThemeSwitcher } from './ui/components/ThemeSwitcher'
import { FontSizeSwitcher } from './ui/components/FontSizeSwitcher'
import { WipeLocalDataButton } from './ui/components/WipeLocalDataButton'

export default function App() {
  return (
    <div className="flex flex-col min-h-dvh">
      <header className="mx-auto w-full max-w-7xl px-6 py-6 flex items-center justify-between gap-3 flex-wrap">
        <Link
          to="/"
          className="text-lg no-underline"
          style={{
            fontFamily: 'var(--font-display)',
            color: 'var(--color-fg)',
          }}
        >
          Markfy
        </Link>
        <div className="flex items-center gap-4 flex-wrap">
          <AuthBadge />
          <FontSizeSwitcher />
          <LocaleSwitcher />
          <ThemeSwitcher />
        </div>
      </header>

      <Outlet />

      <footer
        className="mt-auto px-6 py-6 flex items-center justify-center gap-4 text-xs flex-wrap"
        style={{ color: 'var(--color-muted)' }}
      >
        <WipeLocalDataButton />
        <Link
          to="/privacy"
          className="text-xs underline"
          style={{ color: 'var(--color-muted)' }}
        >
          Privacy
        </Link>
        <HealthPill />
      </footer>

      <ConsentPrompt />
    </div>
  )
}
